export default "__VITE_ASSET___a$qyfqt__"